import authApi from '@/api/authApi'
import * as roles from '@/constants/roles'
import roleUtil from '@/utils/roleUtil'
import Vue from 'vue'
export default {
  namespaced: true,

  state: {
    authenticated: false,
    user: null,
    isSuperAdmin: false,
    isAdmin: false
  },
  getters: {},
  mutations: {
    SET_AUTHENTICATED (state, value) {
      state.authenticated = value
      localStorage.setItem('isLoggedIn', value)
    },
    SET_USER (state, value) {
      state.user = value
      const roleId = roleUtil.getRoleId(value)
      if (roleId === roles.SUPER_ADMIN) {
        state.isSuperAdmin = true
        state.isAdmin = false
      } else if (roleId === roles.ADMIN) {
        state.isAdmin = true
        state.isSuperAdmin = false
      }
    },
    SET_SUPER_ADMIN_ROLE (state, value) {
      state.isSuperAdmin = value
      state.isAdmin = !value
      Vue.$log.info('is super admin', [value])
    },
    SET_ADMIN_ROLE (state, value) {
      state.isAdmin = value
      state.isSuperAdmin = !value
      Vue.$log.info('is admin', [value])
    }
  },
  actions: {
    async login ({ commit }, credentials) {
      const response = await authApi.login(credentials)

      const user = response.data

      commit('SET_AUTHENTICATED', true)
      commit('SET_USER', user?.user)
      return user
    },
    async logout ({ commit }) {
      await authApi.logout()
      commit('SET_AUTHENTICATED', false)
      commit('SET_USER', null)
      commit('SET_SUPER_ADMIN_ROLE', false)
      commit('SET_ADMIN_ROLE', false)
      return null
    }
  }
}
